var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uptop",attrs:{"id":"uptop"}},[_c('img',{attrs:{"src":require("../assets/images/icon/totop.png"),"id":"to-top"},on:{"click":_vm.clickToTop}})])}
var staticRenderFns = []

export { render, staticRenderFns }